import React from 'react'
import get from 'lodash/get'

class VideoCarouselBlock extends React.Component {
  render() {
    const fields = this.props.fields
    const videoLinks = fields.videoLinks
    const primaryLink = videoLinks[0]
    const body = get(fields, 'body.subheader')
    let text
    let secondaryLinks

    if (fields.header || body) {
      text = (
        <div className="videoLink__text">
          <h3 className="videoLink__header">{fields.header}</h3>
          <div className="videoLink__body">{body}</div>
        </div>
      )
    }

    if (videoLinks.length > 1) {
      secondaryLinks = videoLinks.slice(1).map((vlink, i) => {
        const linkFields = vlink.fields || {}
        return (
          <div key={i} className="videoLink videoLink--small">
            <iframe
              width="100%"
              src={linkFields.url}
              frameBorder="0"
              allowFullScreen
              title={linkFields.name}
            />
            <div className="videoLink__secondaryText">{linkFields.name}</div>
          </div>
        )
      })
    }

    const linkFields = primaryLink.fields || {}
    return (
      <div className="videoCarouselBlock">
        <div className="videoLink">
          <iframe src={linkFields.url} frameBorder="0" allowFullScreen title={linkFields.name} />
        </div>
        <div className="videoCarouselBlock__title">{text}</div>
        <div className="videoCarouselBlock__secondaryLinks">{secondaryLinks}</div>
      </div>
    )
  }
}

export default VideoCarouselBlock
